import React, { useEffect, useRef } from "react";

import Stand from "components/stand";
import { useMe, useVarParam, useLogout } from "components/use-hooks";
import { Wraps, Buttons } from "components/layout";
import checkUser from "utils/check-user";
import { Button } from "antd";
import { localizeIt } from "components/service/localize";
import Icons from "../../icons";
import LanguageSelect from "../language-select";

import "./top-menu-bar.scss";


const TopMenuBar = () => {
    const { me } = useMe();
    const { hasRealActiveEvent } = checkUser;

    const appParams = useVarParam();
    const { logout } = useLogout();
    const headerRef = useRef(null);

    const viewingWithoutEvent = appParams.get("viewingWithoutEvent");
    const hasNoActiveExhibition = !hasRealActiveEvent(me);

    const LeftControl = () => appParams.get("leftHeaderControl");
    const RightControl = () => appParams.get("rightHeaderControl");

    const LogoutButton = () => (
        <Button
            onClick={ () => logout({ redirectRoute: "/" }) }
            className="back-button icon rounded"
        >
            <Icons.Logout />
        </Button>
    );

    const headerTitle = appParams.get("headerTitle") || "";

    const containsExternalExhibition = typeof headerTitle === 'string' &&
        headerTitle.includes(localizeIt("STAND.External_Exhibition"));

    const createMarkup = (html) => {
        if (!html) return { __html: "" };
        return { __html: html };
    };

    const renderHeaderTitle = () => {
        if (!headerTitle) return null;

        if (containsExternalExhibition)
        {
            return (
                <span
                    data-external-exhibition="true"
                    dangerouslySetInnerHTML={ createMarkup(headerTitle) }
                />
            );
        }

        return headerTitle;
    };

    useEffect(() => {
        return () => {
            if (containsExternalExhibition)
            {
                appParams.set({
                    headerTitle: null
                });
            }
        };
    }, [ appParams, containsExternalExhibition ]);

    return (
        <header
            ref={ headerRef }
            className={ `top-menu-bar ${ appParams.get().headerClass.join(" ") }` }
        >
            <Wraps.Container>
                <div className="left-part">
                    { !appParams.get("leftHeaderControl") && (
                        (viewingWithoutEvent && hasNoActiveExhibition)
                            ? <LogoutButton />
                            : <Buttons.Back logo={ appParams.get("logoOn") } />
                    ) }
                    <LeftControl />
                </div>
                <div className="center-part color-primary-op60">
                    { renderHeaderTitle() }
                </div>
                <div className="right-part">
                    { appParams.get("searchOn") && !viewingWithoutEvent && !hasNoActiveExhibition &&
                        <Stand.Modals.Search />
                    }
                    <LanguageSelect />
                    <RightControl />
                </div>
            </Wraps.Container>
        </header>
    );
};


export default TopMenuBar;
